// Marathi content for products, keyed by slug. English lives in products.js.
export const PRODUCTS_MR = {
  "v6-submersible-pump": {
    name: "V6 वॉटर फिल्ड सबमर्सिबल पंप सेट (१५०मिमी)",
    short: "खोलवर पोहोचणारी ताकद — १५०मिमी OD वॉटर-फिल्ड सबमर्सिबल पंप सेट.",
    overview: "आरके जैन V6 वॉटर फिल्ड सबमर्सिबल पंप सेट (१५०मिमी OD) उच्च कामगिरी व दीर्घ आयुष्यासाठी बनवलेला आहे. वॉटर-फिल्ड रचनेमुळे उत्तम कूलिंग, उच्च दर्जाची स्टेनलेस स्टील बॉडी व हाय-टॉर्क मोटरमुळे खोल बोअरवेलसाठी विश्वासार्ह हाय-हेड कामगिरी.",
  },
  "v4-submersible-pump": {
    name: "V4 बोअरवेल सबमर्सिबल पंप",
    short: "आणखी खोलवर पोहोचणारी ताकद — SS 304 बोअरवेल सबमर्सिबल पंप, दीर्घकाळ टिकणारा.",
    overview: "आरके जैन V4 बोअरवेल सबमर्सिबल पंप कामगिरी व टिकाऊपणासाठी बनवलेला आहे. उच्च दर्जाच्या SS 304 मटेरियलमुळे गंज-प्रतिरोधक, शक्तिशाली मोटरसह सर्व परिस्थितीत उच्च कामगिरी — शेत, घरे, उद्योग व सिंचनासाठी योग्य.",
  },
  "self-priming-pump": {
    name: "सेल्फ प्रायमिंग पंप (RKSPS)",
    short: "उच्च कामगिरी | सेल्फ प्रायमिंग | दीर्घ आयुष्य — फूट व्हॉल्व्हची गरज नाही, ८ मीटरपर्यंत सक्शन लिफ्ट.",
    overview: "आरके जैन सेल्फ प्रायमिंग पंप (RKSPS सिरीज) ला फूट व्हॉल्व्हची गरज नाही व ८ मीटरपर्यंत सक्शन लिफ्ट, उच्च डिस्चार्ज व कार्यक्षमता देतो. रस्ट-प्रूफ बॉडी, हाय-एफिशियन्सी मोटर व १००% कॉपर वाइंडिंगमुळे सततच्या वापरासाठी आदर्श — १ वर्ष वॉरंटीसह.",
  },
  "openwell-pump": {
    name: "ओपनवेल सबमर्सिबल पंप",
    short: "उच्च कार्यक्षमता, शक्तिशाली व गंज-प्रतिरोधक ओपनवेल सबमर्सिबल पंप — विहिरी व टाक्यांसाठी.",
    overview: "आरके जैन ओपनवेल सबमर्सिबल पंप विहिरी, टाक्या व सम्पसाठी शक्तिशाली, उच्च-कार्यक्षम कामगिरी देतो. गंज-प्रतिरोधक, कमी देखभाल व दीर्घ आयुष्यासाठी बनवलेला, विश्वासार्ह सहाय्यासह.",
  },
  "aata-chakki-regular": {
    name: "आरके जैन आटा चक्की (रेग्युलर १.५)",
    short: "पॉवर. परफॉर्मन्स. शुद्ध परिणाम. — हर दाणा, शुद्ध आटा, हे आमचे वचन.",
    overview: "आरके जैन आटा चक्की (रेग्युलर १.५) ही आयएसओ एनर्जी सेव्हर मोटरसह आधुनिक घरगुती पिठाची गिरणी आहे. उच्च कार्यक्षमता, कमी वीज वापर व मजबूत बॉडीमुळे दीर्घ आयुष्य — घरच्या घरी सर्व प्रकारच्या धान्याचे बारीक, ताजे व शुद्ध पीठ.",
  },
  "flour-mill": {
    name: "आरके जैन फ्लोअर मिल",
    short: "हर दाणा, उत्तम पिसाईचे वचन — दुकाने व उद्योगांसाठी हेवी ड्युटी फ्लोअर मिल.",
    overview: "आरके जैन फ्लोअर मिल ही हेवी ड्युटी, टिकाऊ मशीन उत्तम पिसाईसाठी बनवलेली आहे. मजबूत बांधणी, हाय परफॉर्मन्स मोटर व कमी देखभालीमुळे फ्लोअर मिल, किराणा दुकान व उद्योगासाठी सर्वोत्तम — ग्राहक समाधान हीच पहिली प्राथमिकता.",
  },
  "pvc-u-agriculture-pipes": {
    name: "पीव्हीसी-यू कृषी पाईप व फिटिंग्ज",
    short: "मजबूत · टिकाऊ · गळतीविरहित · दीर्घ आयुष्य — संपूर्ण पीव्हीसी-यू पाईप व फिटिंग्ज श्रेणी.",
    overview: "आरके जैन पीव्हीसी-यू कृषी पाईप व फिटिंग्ज संपूर्ण श्रेणी देतात — पाईप (२०मिमी ते १६०मिमी), सर्व प्रकारच्या फिटिंग्ज, बॉल व्हॉल्व्ह, ब्रास इन्सर्ट फिटिंग्ज व सॉल्व्हंट सिमेंट. उच्च दाब व कठीण परिस्थितीसाठी, गळतीविरहित, गंज-प्रतिरोधक व इको-फ्रेंडली.",
  },
  "hdpe-pipes-sdr11": {
    name: "एचडीपीई पाईप",
    short: "उत्तम उद्यासाठी परिपूर्ण उपाय — टिकाऊ | गळतीविरहित | गंजमुक्त | दीर्घ आयुष्य.",
    overview: "आरके जैन एचडीपीई पाईप उत्तम उद्यासाठी परिपूर्ण उपाय आहेत — दाब व आघात सहन करणारी उच्च शक्ती, १००% गळतीविरहित जोड, गंज-प्रतिरोधक व इको-फ्रेंडली. पिण्याचे पाणी, सिंचन, औद्योगिक व भूमिगत वापरासाठी आदर्श.",
  },
  "high-pressure-car-washer-rk-2100": {
    name: "हाय प्रेशर कार वॉशर (RK-2100)",
    short: "२१००W पॉवर | १५० बार प्रेशर — कार, बाईक व घर स्वच्छतेसाठी शक्तिशाली हाय-प्रेशर वॉशर.",
    overview: "आरके जैन हाय प्रेशर कार वॉशर (RK-2100) २१००W पॉवर व १५० बार प्रेशरसह कार, बाईक व घराच्या खोल स्वच्छतेसाठी. फोम कॅनन, स्प्रे गन, होज व अधिक अ‍ॅक्सेसरीजसह — घरच्या घरी व्यावसायिक स्वच्छता.",
  },
  "black-white-mulching-film": {
    name: "ब्लॅक व्हाईट मल्चिंग फिल्म",
    short: "उन्नत शेतीची उत्तम सुरुवात — जास्त उत्पादन व तण नियंत्रणासाठी यूव्ही स्टॅबिलाइज्ड मल्चिंग फिल्म.",
    overview: "आरके जैन ब्लॅक व्हाईट मल्चिंग फिल्म जमिनीतील ओलावा टिकवते, तण नियंत्रित करते व मातीचे योग्य तापमान राखते. प्रीमियम कच्च्या मालापासून, यूव्ही स्टॅबिलायझेशनसह दीर्घ आयुष्य — सर्व प्रकारच्या माती व पिकांसाठी योग्य.",
  },
  "aluminium-armoured-cable": {
    name: "३ कोअर ॲल्युमिनियम आर्मर्ड केबल",
    short: "मजबूत कनेक्शन, सुरक्षित वीज भविष्य — १००% शुद्ध ॲल्युमिनियम कंडक्टर आर्मर्ड केबल.",
    overview: "आरके जैन ३ कोअर ॲल्युमिनियम आर्मर्ड केबलमध्ये १००% शुद्ध ॲल्युमिनियम कंडक्टर व आर्मर्ड संरक्षण असून मजबुती व सुरक्षितता देते. उत्तम इन्सुलेशन, उष्णता व ओलावा प्रतिकार व १००% तपासलेली गुणवत्ता.",
  },
  "submersible-pump-cable": {
    name: "सबमर्सिबल पंप केबल",
    short: "मजबूत केबल, वर्षानुवर्षे टिकणारी — १००% वॉटरप्रूफ शुद्ध कॉपर सबमर्सिबल पंप केबल.",
    overview: "आरके जैन सबमर्सिबल पंप केबल खोल पाण्याच्या पंपांसाठी बनवलेली असून १००% वॉटरप्रूफ, ओलावा-प्रतिरोधक इन्सुलेशन व शुद्ध कॉपर कंडक्टरसह जास्तीत जास्त कार्यक्षमता. अतिरिक्त लवचिक, गुंता न होणारी व उष्णता प्रतिरोधक.",
  },
  "column-pipes-borewell": {
    name: "कॉलम पाईप",
    short: "खोल पाणी उपशासाठी बोअरवेल पाईप — भारतातील पहिली इम्पॅक्ट-सस्टेनिंग लॉक सिस्टीम.",
    overview: "आरके जैन कॉलम पाईप खोल पाणी उपशासाठी बनवलेले बोअरवेल पाईप असून भारतातील पहिल्या इम्पॅक्ट-सस्टेनिंग लॉक सिस्टीमसह गळतीविरहित, सुरक्षित जोड. लेड-फ्री व सुरक्षित, उच्च टिकाऊपणा, गुळगुळीत फिनिश व प्रीमियम कच्चा माल.",
  },
  "pvc-suction-hose-pipe": {
    name: "पीव्हीसी सक्शन होज पाईप",
    short: "हेवी ड्युटी, लवचिक व बहुउपयोगी पीव्हीसी सक्शन होज — शेती, बोअरवेल, औद्योगिक व घरगुती वापरासाठी आदर्श.",
    overview: "आरके जैन पीव्हीसी सक्शन होज पाईप हा हेवी ड्युटी, लवचिक व बहुउपयोगी होज असून पाणी शोषण व विसर्जनासाठी बनवलेला आहे. उच्च दर्जाच्या पीव्हीसीपासून बनवलेला व गुळगुळीत आतील पृष्ठभागामुळे उत्तम सक्शन — शेती, बोअरवेल, औद्योगिक व घरगुती वापरासाठी आदर्श.",
  },
  "mini-chaff-cutter-rkc-1": {
    name: "मिनी कडबा कुट्टी यंत्र (RKC-1)",
    short: "लहान यंत्र, मोठे फायदे — हिरवा चारा, वाळलेले गवत, कडबा, मका इत्यादी कापण्यासाठी.",
    overview: "आरके जैन मिनी कडबा कुट्टी यंत्र (RKC-1) हे कॉम्पॅक्ट व शक्तिशाली चारा कापणी यंत्र आहे — हुशार शेतकऱ्याची निवड. हिरवा चारा, वाळलेले गवत, कडबा, मका, बाजरी, ज्वारी जलद, बारीक व एकसमान कापते.",
  },
  "k-flex-submain-pipes": {
    name: "के-फ्लेक्स सबमेन पाईप",
    short: "कार्यक्षम, टिकाऊ व शाश्वत सिंचनासाठी — शेतकऱ्यांचा विश्वास, गुणवत्तेची निवड.",
    overview: "आरके जैन के-फ्लेक्स सबमेन पाईप कार्यक्षम, टिकाऊ व शाश्वत सिंचनासाठी बनवलेले आहेत. प्रीमियम कच्च्या मालापासून, उच्च लवचिकता व एकसमान भिंत जाडीमुळे गळतीविरहित — मेड इन इंडिया, दीर्घकाळ टिकणारे.",
  },
  "premium-garden-pipe": {
    name: "प्रीमियम गार्डन पाईप",
    short: "हिरव्यागार बागेसाठी व चांगल्या उद्यासाठी — इको-फ्रेंडली, नॉन-टॉक्सिक, लेड-फ्री ३-लेयर पीव्हीसी गार्डन पाईप.",
    overview: "आरके जैन प्रीमियम गार्डन पाईप हा मजबूत, लवचिक ३-लेयर पीव्हीसी होज असून १००% व्हर्जिन मटेरियलपासून बनवलेला आहे. इको-फ्रेंडली, नॉन-टॉक्सिक व लेड-फ्री — यूव्ही संरक्षण बाह्य थर, उच्च शक्ती मधला थर व गुळगुळीत प्रवाह आतील थर, घर व व्यावसायिक वापरासाठी योग्य.",
  },
  "v4-pumps": {
    name: "V4 सबमर्सिबल पंप",
    short: "खोल, सातत्यपूर्ण पाणीपुरवठ्यासाठी बनवलेले कॉम्पॅक्ट ४-इंच बोअरवेल पंप.",
    overview: "आरके जैन V4 सबमर्सिबल पंप ४-इंच बोअरवेलसाठी अचूकपणे बनवलेले असून शेती, घरे व लहान उद्योगांना विश्वासार्ह पाणीपुरवठा देतात. सततच्या वापरासाठी तयार, कार्यक्षमता, टिकाऊपणा व शांत कामगिरीचा उत्तम मेळ.",
    features: ["गंज न लागणारी स्टेनलेस स्टील बांधणी", "कमी खर्चासाठी उच्च कार्यक्षम हायड्रॉलिक्स", "सततच्या भारातही थंड व शांत कामगिरी", "सोपी स्थापना व कमी देखभाल"],
  },
  "v6-pumps": {
    name: "V6 सबमर्सिबल पंप",
    short: "मोठ्या कृषी व व्यावसायिक गरजांसाठी शक्तिशाली ६-इंच पंप.",
    overview: "V6 श्रेणी मोठ्या शेतांसाठी, मळ्यांसाठी व व्यावसायिक पाणी प्रणालींसाठी उच्च प्रवाहाच्या गरजांसाठी बनवलेली आहे. मजबूत साहित्य व अनुकूल रचनेमुळे हंगामामागून हंगाम विश्वासार्ह कामगिरी.",
    features: ["मोठ्या क्षेत्रातील सिंचनासाठी उच्च प्रवाह", "दीर्घ आयुष्यासाठी मजबूत थ्रस्ट बेअरिंग", "कठीण बोअरवेलसाठी वाळू हाताळण्याची क्षमता", "विस्तृत व्होल्टेज सहनशीलता"],
  },
  "self-priming-pumps": {
    name: "सेल्फ प्रायमिंग पंप",
    short: "घरे, बागा व लहान उद्योगांसाठी जलद सेल्फ-प्रायमिंग मोनोब्लॉक पंप.",
    overview: "वारंवार हाताने प्रायमिंग न करता पाणी जलद ओढणारे सेल्फ-प्रायमिंग मोनोब्लॉक पंप — घरगुती पाणीपुरवठा, बागा व लहान दाब वाढवण्याच्या गरजांसाठी आदर्श.",
    features: ["जलद सेल्फ-प्रायमिंग क्रिया", "कॉम्पॅक्ट मोनोब्लॉक रचना", "कमी कंपनासह गुळगुळीत कामगिरी", "थर्मल ओव्हरलोड संरक्षण"],
  },
  "mudpumps": {
    name: "मडपंप",
    short: "गढूळ, गाळयुक्त पाणी सहज उपसणारे मजबूत डीवॉटरिंग पंप.",
    overview: "बांधकाम स्थळे, तळी व पूरप्रवण भागातील गाळ, चिखल व घाण पाणी न अडकता हाताळण्यासाठी बनवलेले मजबूत मडपंप.",
    features: ["घन पदार्थ व गाळयुक्त पाणी हाताळणी", "झीज-प्रतिरोधक इम्पेलर", "उच्च प्रवाह डीवॉटरिंग क्षमता", "कठीण साइट परिस्थितीसाठी बनवलेले"],
  },
  "battery-pumps": {
    name: "बॅटरी पंप",
    short: "फवारणी, स्वच्छता व वीजविरहित वापरासाठी पोर्टेबल रिचार्जेबल पंप.",
    overview: "कुठेही पाणी व फवारणीची शक्ती नेणारे तारविरहित, रिचार्जेबल बॅटरी पंप — वीज नसलेली शेते, स्वच्छता व पोर्टेबल कामांसाठी उत्तम.",
    features: ["रिचार्जेबल, तारविरहित वापर", "हलके व पोर्टेबल", "वीजविरहित शेतांसाठी आदर्श", "दीर्घ बॅटरी कार्यकाळ"],
  },
  "sprinklers": {
    name: "स्प्रिंकलर प्रणाली",
    short: "पाणी वाचवून उत्पादन वाढवणारे एकसमान वरून सिंचन.",
    overview: "शेते, हरळी व मळ्यांवर पाणी एकसमान पसरवणाऱ्या अभियंता-रचित स्प्रिंकलर प्रणाली — पाण्याची नासाडी कमी करून पिकांची एकसमानता सुधारते.",
    features: ["एकसमान, विस्तृत क्षेत्र सिंचन", "पाणीबचत करणारी रचना", "टिकाऊ, यूव्ही-स्थिर घटक", "मॉड्युलर व सहज विस्तारयोग्य"],
  },
  "drip-irrigation": {
    name: "ठिबक सिंचन",
    short: "थेट मुळांपर्यंत पाणी पोहोचवणाऱ्या अचूक ठिबक नळ्या.",
    overview: "पिकांना जिथे गरज तिथेच पाणी व अन्नद्रव्ये पोहोचवणारे संपूर्ण ठिबक सिंचन उपाय — पाणी व खताचा वापर कमी करून उत्पादन वाढवतात.",
    features: ["६०% पर्यंत पाणीबचत", "अचूक मूळक्षेत्र पुरवठा", "अडथळा न येणारे एमिटर", "रांग व फळबाग पिकांसाठी आदर्श"],
  },
  "mulching-solutions": {
    name: "मल्चिंग उपाय",
    short: "ओलावा टिकवून तण रोखणारे संरक्षक मल्चिंग फिल्म.",
    overview: "जमिनीतील ओलावा टिकवणारे, तापमान नियंत्रित करणारे व तण रोखणारे उच्च दर्जाचे मल्चिंग फिल्म — शेतकऱ्यांचा खर्च कमी करून उत्पादकता वाढवतात.",
    features: ["उत्तम ओलावा टिकवण", "तण नियंत्रण", "यूव्ही-स्थिर, दीर्घ आयुष्य", "पिकांची गुणवत्ता सुधारते"],
  },
  "hdpe-pipes": {
    name: "एचडीपीई पाईप",
    short: "दीर्घकाळ पाणी वाहतुकीसाठी लवचिक, उच्च-शक्तीचे पाईप.",
    overview: "उत्तम लवचिकता, रासायनिक प्रतिकार व गळतीविरहित जोड देणारे एचडीपीई पाईप — सिंचन व पाणीपुरवठा जाळ्यांचा विश्वासार्ह कणा.",
    features: ["गळतीविरहित फ्यूज्ड जोड", "गंज व रासायनिक प्रतिरोधक", "लवचिक व आघात-प्रतिरोधक", "दीर्घ सेवा आयुष्य"],
  },
  "pvc-pipes": {
    name: "पीव्हीसी पाईप",
    short: "प्लंबिंग व सिंचनासाठी विश्वासार्ह, हलके पाईप.",
    overview: "प्लंबिंग, सिंचन व निचऱ्यासाठी टिकाऊ पीव्हीसी पाईप — हलके, स्थापण्यास सोपे व वर्षानुवर्षे सातत्यपूर्ण प्रवाह देणारे.",
    features: ["उत्तम प्रवाहासाठी गुळगुळीत आतील पृष्ठभाग", "हलके व सहज स्थापना", "गंजमुक्त", "सातत्यपूर्ण भिंत जाडी"],
  },
  "column-pipes": {
    name: "कॉलम पाईप",
    short: "सबमर्सिबल स्थापनेसाठी उच्च-तन्यता रायझर पाईप.",
    overview: "खोल बोअरवेलमध्ये सबमर्सिबल पंप सुरक्षितपणे उचलण्यासाठी बनवलेले थ्रेडेड कॉलम पाईप — उच्च तन्यता शक्ती व गळतीविरहित, सहज जोडता येणारे जोड.",
    features: ["उच्च तन्यता व भार क्षमता", "गळतीविरहित थ्रेडेड जोड", "गंज न लागणारे साहित्य", "जलद जोडणी"],
  },
  "garden-pipes": {
    name: "गार्डन पाईप",
    short: "बागा, घरे व स्वच्छतेसाठी लवचिक दैनंदिन नळ्या.",
    overview: "पाणी देणे, स्वच्छता व दैनंदिन वापरासाठी टिकाऊ, न वळणारे गार्डन पाईप — सर्व ऋतूंत लवचिक व दीर्घकाळ टिकणारे.",
    features: ["वळण व पीळ प्रतिरोधक", "सर्व हवामानात लवचिक", "दीर्घकाळ टिकणारे साहित्य", "विविध आकारांत उपलब्ध"],
  },
  "copper-cables": {
    name: "कॉपर केबल",
    short: "सुरक्षित, कार्यक्षम वीजपुरवठ्यासाठी उच्च-वाहकता कॉपर केबल.",
    overview: "उत्तम वाहकता व उष्णता प्रतिकार देणाऱ्या दर्जेदार कॉपर केबल — पंप व औद्योगिक रचनांमध्ये सुरक्षित, कार्यक्षम वीज वहनासाठी बनवलेल्या.",
    features: ["उच्च विद्युत वाहकता", "उष्णता व आग प्रतिरोधक इन्सुलेशन", "कमी वहन हानी", "आयएसआय-दर्जाचे साहित्य"],
  },
  "aluminium-cables": {
    name: "ॲल्युमिनियम केबल",
    short: "मोठ्या वीज वितरणासाठी किफायतशीर ॲल्युमिनियम केबल.",
    overview: "ओव्हरहेड व मोठ्या प्रमाणातील वीज वितरणासाठी आदर्श हलक्या, किफायतशीर ॲल्युमिनियम केबल — अनुकूल खर्चात विश्वासार्ह कामगिरी.",
    features: ["हलक्या व किफायतशीर", "वजनाच्या तुलनेत चांगली वाहकता", "टिकाऊ इन्सुलेशन", "वितरण लाईनसाठी आदर्श"],
  },
  "car-washers": {
    name: "कार वॉशर",
    short: "स्वच्छ वाहने व पृष्ठभागांसाठी उच्च-दाब वॉशर.",
    overview: "स्वच्छता जलद व सहज करणारे शक्तिशाली उच्च-दाब कार वॉशर — घरे, शोरूम व व्यावसायिक सर्व्हिस सेंटरसाठी.",
    features: ["उच्च-दाब जेट स्वच्छता", "ऊर्जा व पाणीबचत", "कॉम्पॅक्ट, पोर्टेबल रचना", "टिकाऊ मोटर"],
  },
  "stp-systems": {
    name: "एसटीपी प्रणाली",
    short: "स्वच्छ, पुनर्वापरयोग्य पाण्यासाठी सांडपाणी प्रक्रिया प्रकल्प.",
    overview: "सांडपाण्यावर सुरक्षित, पुनर्वापरयोग्य दर्जापर्यंत प्रक्रिया करणारे सांडपाणी प्रक्रिया प्रकल्प (एसटीपी) उपाय — समाज व उद्योगांसाठी शाश्वत पाणी व्यवस्थापनास सहाय्य.",
    features: ["कार्यक्षम सांडपाणी प्रक्रिया", "पाण्याचा पुनर्वापर शक्य", "कॉम्पॅक्ट, मॉड्युलर प्रणाली", "कमी परिचालन खर्च"],
  },
  "chaff-cutters": {
    name: "कडबा कुट्टी यंत्र",
    short: "जनावरांचा चारा जलद तयार करणारे मजबूत कडबा कुट्टी यंत्र.",
    overview: "चारा जलद व एकसमान कापणारी टिकाऊ कडबा कुट्टी यंत्रे — दुग्ध व पशुपालक शेतकऱ्यांचा वेळ व श्रम वाचवतात.",
    features: ["जलद, एकसमान कापणी", "मजबूत व सुरक्षित बांधणी", "कमी देखभाल", "उच्च क्षमता"],
  },
  "aata-chakki": {
    name: "आटा चक्की",
    short: "ताज्या, आरोग्यदायी दळणासाठी घरगुती व व्यावसायिक पिठाच्या गिरण्या.",
    overview: "घरे व दुकानांसाठी कार्यक्षम आटा चक्की (पिठाच्या गिरण्या) — सातत्यपूर्ण बारीकपणासह ताजे, स्वच्छ पीठ दळा.",
    features: ["सातत्यपूर्ण, बारीक दळण", "स्वच्छ ताजे पीठ", "टिकाऊ दगड व मोटर", "घरगुती व व्यावसायिक मॉडेल"],
  },
  "rasvanti-machines": {
    name: "रसवंती यंत्र",
    short: "उच्च उत्पादन व स्वच्छतेसाठी बनवलेली ऊस रस काढणी यंत्रे.",
    overview: "जास्तीत जास्त रस काढणी व स्वच्छ कामगिरीसाठी बनवलेली रसवंती (ऊस रस) यंत्रे — रस विक्रेते व व्यावसायिक दुकानांसाठी उत्तम.",
    features: ["उच्च रस उत्पादन", "स्वच्छ स्टेनलेस संपर्क भाग", "मजबूत, सततच्या वापराची मोटर", "स्वच्छ करण्यास सोपी"],
  },
};
